import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-8 flex justify-center" }
const _hoisted_2 = { class: "bg-red-50 p-8 rounded-full ring-8 ring-red-50/50" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-gray-800 mb-4" }, "Acesso Não Autorizado", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-lg mb-10 leading-relaxed max-w-lg mx-auto" }, [
  /*#__PURE__*/_createTextVNode(" Você não possui permissão para acessar esta página. "),
  /*#__PURE__*/_createElementVNode("br", { class: "hidden sm:block" }),
  /*#__PURE__*/_createTextVNode(" Se você acredita que isso é um erro, verifique suas credenciais ou entre em contato com o administrador do sistema. ")
], -1)
const _hoisted_5 = { class: "flex flex-col sm:flex-row gap-4 justify-center items-center w-full" }

import { useRouter } from 'vue-router'
import { mdiShieldLockOutline } from '@mdi/js'
import PATHS from '@/router/paths'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotAuthorized',
  setup(__props) {

const router = useRouter()

const goToLogin = () => {
  router.push(PATHS.SIGNIN)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "h-screen flex items-center justify-center bg-gray-50/50",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        align: "center",
        class: "text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8",
            lg: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiShieldLockOutline),
                    size: "100",
                    class: "text-red-500"
                  }, null, 8, ["icon"])
                ])
              ]),
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "w-full sm:w-auto h-[56px] font-bold capitalize px-8 text-white",
                  elevation: "0",
                  onClick: goToLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Voltar para o login ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})